import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tma-nodejs',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './tma-nodejs.component.html',
  styleUrl: './tma-nodejs.component.css'
})
export class TmaNodejsComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("TMA Node.js & NestJS : Maintenance Backend Expert — Agréée CII");
    this.metaService.updateTag({ name: 'description', content: "Externalisez la maintenance de votre backend Node.js. Expertise NestJS, TypeScript et API. Sécurisez vos applications critiques avec notre TMA éligible au Crédit Impôt Innovation." });
  }
}